export default "__VITE_ASSET__8d3731bf__"